<template>
  <div>
    <b-field class="commonrules-grp" label="Hotel is not in the following list of preferred chains ">
       <TagAutocomplete
         placeholder="e.g. Hilton"
         icon="magnify"
         :chainData="airVendors"
         :selected="hotelPreferredVendors"
         @list="getSelectedHotelVendors()"
         ></TagAutocomplete>
        </b-field>
   </div>
 </template>
  <script>
   import TagAutocomplete from '../../Tags/TagAutocomplete.vue';
   
    export default {
      name: "HotelPreferredVendors",
      components: {
        TagAutocomplete
      },
      data() {
        return {
          hotelPreferredVendors:[]
        }
      },
      computed:{
        airVendors(){
           return Object.entries(this.$store.state.bookTravel.vendors.hotelChains);
        }
      },
      methods:{
        getSelectedHotelVendors() {
          this.$emit('hotelPreferredVendors',this.hotelPreferredVendors);
        }
      },
    }
  </script>

  <style scoped>
  </style>